import { Skeleton, Stack, VStack } from "@chakra-ui/react";

export const Loaders = () => {
  return (
    <VStack justifyContent={"center"} >
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
      <Skeleton width={"98%"} height="120px" />
    </VStack>
  );
};
